import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results", "spinner"]

  connect() {
  }

  onSearch(event) {
    const query = event.target.value.trim()

    if (query.length >= 2) {
      this.performSearch(query)
    } else {
      this.clearResults()
    }
  }

  showSpinner() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove('d-none')
    }
  }

  hideSpinner() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add('d-none')
    }
  }

  performSearch(query) {
    this.showSpinner()

    const url = new URL(window.location)
    url.searchParams.set('search', query)

    fetch(url, {
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.text())
    .then(html => {
      // Actualizar solo la lista de contactos
      const parser = new DOMParser()
      const doc = parser.parseFromString(html, 'text/html')

      // Actualizar la lista de contactos
      const newContactList = doc.querySelector('.contact-list')
      const currentContactList = document.querySelector('.contact-list')
      if (newContactList && currentContactList) {
        currentContactList.innerHTML = newContactList.innerHTML
      }

      // Actualizar los resultados de búsqueda
      const newSearchResults = doc.querySelector('.search-results')
      const currentSearchResults = document.querySelector('.search-results')
      if (newSearchResults) {
        if (currentSearchResults) {
          currentSearchResults.innerHTML = newSearchResults.innerHTML
        } else {
          // Insertar después del buscador
          const searchBox = document.querySelector('.search-box')
          searchBox.insertAdjacentElement('afterend', newSearchResults)
        }
      }
    })
    .catch(error => {
      console.error('Error en búsqueda:', error)
    })
    .finally(() => {
      this.hideSpinner()
    })
  }

  clearResults() {
    this.hideSpinner()

    const searchResults = document.querySelector('.search-results')
    if (searchResults) {
      searchResults.remove()
    }

    // Recargar la lista completa de contactos
    const url = new URL(window.location)
    url.searchParams.delete('search')

    fetch(url, {
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser()
      const doc = parser.parseFromString(html, 'text/html')

      const newContactList = doc.querySelector('.contact-list')
      const currentContactList = document.querySelector('.contact-list')
      if (newContactList && currentContactList) {
        currentContactList.innerHTML = newContactList.innerHTML
      }
    })
    .catch(error => {
      console.error('Error al limpiar búsqueda:', error)
    })
  }
}
